import { render, staticRenderFns } from "./Kkt.vue?vue&type=template&id=ed416a4a&scoped=true&"
import script from "./Kkt.vue?vue&type=script&lang=ts&"
export * from "./Kkt.vue?vue&type=script&lang=ts&"
import style0 from "./Kkt.vue?vue&type=style&index=0&id=ed416a4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed416a4a",
  null
  
)

export default component.exports